import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./sass/main/main.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux";
import "bootstrap/dist/css/bootstrap.min.css";
import i18n from "./i18-next/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
